module.exports = __webpack_public_path__ + "static/img/modular.12e5024.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/modular.jpg
// module id = dnnA
// module chunks = 2